import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SPCandidateHistorySchedulingNcarbExamAuthFormLocType } from '../ncarb-exam-auth-form/ncarb-exam-auth-form.locs';

export const ncarbSchedulingPathStart = 'Candidate|Scheduling|Scheduling|';
export const ncarbSchedulingSharedProperties: Pick<
	LocDef,
	'shared' | 'htmlAllowed' | 'feature' | 'portal'
> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSchedulingNcarbAuthorizationDetail,
	portal: 'SP',
};

export type SPCandidateHistorySchedulingNcarbExamAuthRevokeLocNames =
	| 'SPCandidateHistorySchedulingNcarbExamAuthRevokeTitle'
	| 'SPCandidateHistorySchedulingNcarbExamAuthRevokeMessage'
	| 'SPCandidateHistorySchedulingNcarbExamAuthRevokeButton'
	| 'SPCandidateHistorySchedulingNcarbExamAuthUnrevokeTitle'
	| 'SPCandidateHistorySchedulingNcarbExamAuthUnrevokeMessage'
	| 'SPCandidateHistorySchedulingNcarbExamAuthUnrevokeButton'
	| 'SPCandidateHistorySchedulingNcarbExamAuthRevokeCancelButton';

export const spCandidateHistorySchedulingNcarbExamAuthRevokeLocs: LocDefs<SPCandidateHistorySchedulingNcarbExamAuthRevokeLocNames> =
	{
		SPCandidateHistorySchedulingNcarbExamAuthRevokeTitle: {
			defaultValue: 'Revoke Authorization',
			description: 'Dialog title for the revoke authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Revoke Authorization|Dialog Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthRevokeMessage: {
			defaultValue: 'You are about to revoke the following authorization. Please confirm.',
			description: 'Message to confirm the revoke authorization.',
			displayPath: `${ncarbSchedulingPathStart}Revoke Authorization|Message`,
			displayType: 'Content',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthRevokeButton: {
			defaultValue: 'Revoke Authorization',
			description: 'Button to revoke the authorization.',
			displayPath: `${ncarbSchedulingPathStart}Revoke Authorization|Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthUnrevokeTitle: {
			defaultValue: 'Un-Revoke Authorization',
			description: 'Dialog title for the un-revoke authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Un-Revoke Authorization|Dialog Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthUnrevokeMessage: {
			defaultValue: 'You are about to un-revoke the following authorization. Please confirm.',
			description: 'Message to confirm the un-revoke authorization.',
			displayPath: `${ncarbSchedulingPathStart}Un-Revoke Authorization|Message`,
			displayType: 'Content',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthUnrevokeButton: {
			defaultValue: 'Un-Revoke Authorization',
			description: 'Button to un-revoke the authorization.',
			displayPath: `${ncarbSchedulingPathStart}Un-Revoke Authorization|Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthRevokeCancelButton: {
			defaultValue: 'Cancel',
			description: 'Button to cancel the revoke authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Revoke Authorization|Cancel Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbExamAuthRevokeLocType =
	LocMap<SPCandidateHistorySchedulingNcarbExamAuthRevokeLocNames> &
		SPCandidateHistorySchedulingNcarbExamAuthFormLocType;
